module.exports = __webpack_public_path__ + "static/media/plus.fc4c5ed5.svg";